import React from 'react';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';

export default function DropMenuButton({
  mainButtonProps,
  menuItems = [],
  menuIcon = <MoreVertIcon />,
  style
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  return (
    <div style={{ display: 'flex', alignItems: 'center', width: '100%', ...style }}>
      <Button
        {...mainButtonProps}
        style={{ flex: 1, ...mainButtonProps.style }}
      >
        {mainButtonProps.children}
      </Button>
      <IconButton
        aria-label="more"
        aria-controls={open ? 'drop-menu-button-menu' : undefined}
        aria-haspopup="true"
        onClick={handleMenuClick}
        style={{ marginLeft: 4 }}
      >
        {menuIcon}
      </IconButton>
      <Menu
        id="drop-menu-button-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleMenuClose}
      >
        {menuItems.map((item, idx) => (
          <MenuItem
            key={item.label || idx}
            onClick={() => {
              handleMenuClose();
              if (item.onClick) item.onClick();
            }}
          >
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
} 